<template>
    <nav class="navbar navbar-expand-lg">
        <router-link to="/auth/dashboard" class="navbar-brand">
            1Autorent
        </router-link>
        <button class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbar"
                aria-controls="navbar"
                :aria-expanded="show"
                aria-label="Toggle navigation"
                :class="{'show': show}"
                @click="show = !show">
            <span class="navbar-toggler-icon"/>
        </button>
        <div class="collapse navbar-collapse" id="navbar" :class="{'show': show}">
            <ul class="navbar-nav mr-auto">
                <router-link to="/auth/dashboard" class="nav-item" tag="li" @click.native="close" exact>
                    <a class="nav-link">{{ $t('Dashboard') }}</a>
                </router-link>
                <router-link to="/auth/booking" class="nav-item" tag="li" @click.native="close" exact>
                    <a class="nav-link">{{ $t('Bookings') }}</a>
                </router-link>
                <router-link v-if="$store.getters.canViewVehicles" to="/auth/vehicles" class="nav-item" tag="li" @click.native="close" exact>
                    <a class="nav-link">{{ $t('Vehicles') }}</a>
                </router-link>
                <router-link v-if="$store.getters.canViewClients" to="/auth/clients" class="nav-item" tag="li" @click.native="close" exact>
                    <a class="nav-link">{{ $t('Clients') }}</a>
                </router-link>
                <router-link v-if="$store.getters.canViewContracts" to="/auth/contracts" class="nav-item" tag="li" @click.native="close" exact>
                    <a class="nav-link">{{ $t('Contracts') }}</a>
                </router-link>
                <router-link v-if="$store.getters.canViewOffers" to="/auth/special-offers" class="nav-item" tag="li" @click.native="close" exact>
                    <a class="nav-link">{{ $t('Special offers') }}</a>
                </router-link>
                <router-link v-if="$store.getters.canViewUsers" to="/auth/users" class="nav-item" tag="li" @click.native="close" exact>
                    <a class="nav-link">{{ $t('Users') }}</a>
                </router-link>
                <router-link v-if="$store.getters.canViewSettings" to="/auth/settings" class="nav-item" tag="li" @click.native="close">
                    <a class="nav-link">{{ $t('Settings') }}</a>
                </router-link>
            </ul>
            <ul class="navbar-nav ml-auto">
                <router-link to="/auth/profile" class="nav-item" tag="li" @click.native="close" exact>
                    <a class="nav-link">{{ $t('My profile') }}</a>
                </router-link>
                <locale-dropdown @close="close"/>
            </ul>
            <router-link to="/" class="btn btn-primary btn-sm mr-2 text-white" exact>
                {{ $t('Public') }}
            </router-link>
            <app-button native-type="button" @click="logout" small>
                {{ $t('Log out') }}
            </app-button>
        </div>
    </nav>
</template>

<script>
import LocaleDropdown from './LocaleDropdown';

export default {
    data() {
        return {
            show: false
        };
    },
    methods: {
        logout() {
            this.$store.dispatch('LOGOUT');
        },
        close() {
            this.show = false;
        }
    },
    components: {
        LocaleDropdown
    },
    created() {
        this.$store.dispatch('GET_USER_PERMISSIONS');
    }
};
</script>
